<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    :color="$vuetify.theme.dark ? '' : 'white'"
    flat
    height="75"
    elevation="0"
  >
    <v-btn
      class="mr-3"
      :style="
        $vuetify.theme.dark
          ? 'box-shadow: 0px 0px 3px 0px #dcdcdc54'
          : 'box-shadow: 0px 0px 3px 0px rgba(100,100,100,0.1)'
      "
      fab
      small
      @click="setDrawer(!drawer)"
    >
      <v-icon v-if="value"> mdi-view-quilt </v-icon>
      <v-icon v-else> mdi-dots-vertical </v-icon>
    </v-btn>

    <v-toolbar-title class="hidden-sm-and-down font-weight-light" />
    <v-spacer />
    {{ userMe.name }}

    <v-spacer />

    <!-- <v-text-field
      :label="$t('search')"
      color="secondary"
      hide-details
      style="max-width: 300px"
    >
      <template v-if="$vuetify.breakpoint.mdAndUp" v-slot:append-outer>
        <v-btn class="mt-n2" elevation="1" fab small>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </template>
    </v-text-field> -->

    <div class="mx-3" />
    <!-- <v-menu
      bottom
      left
      offset-y
      origin="top right"
      transition="scale-transition"
    > -->
    <!-- <template v-slot:activator="{ attrs, on }">
        <v-btn class="ml-2" min-width="0" text v-bind="attrs" v-on="on">
          <v-badge color="red" overlap>
            <template v-slot:badge>
              <span>{{ notifications.length }}</span>
            </template>

            <v-icon>mdi-bell</v-icon>
          </v-badge>
        </v-btn>
      </template> -->
    <!-- <v-list width="380">
        <v-subheader
          >notifaction <v-spacer></v-spacer>
          <v-icon>mdi-bell</v-icon></v-subheader
        ><v-divider></v-divider>
        <v-virtual-scroll :items="notifications" :item-height="60" height="300">
          <template v-slot:default="{ item }">
            <v-list-item> -->
    <!-- <v-list-item-avatar>
                <v-avatar size="56" class="white--text">
                  {{ item.text }}
                </v-avatar>
              </v-list-item-avatar> -->

    <!-- <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  item.created_at
                }}</v-list-item-subtitle>
              </v-list-item-content> -->

    <!-- <v-list-item-action>
                <v-btn depressed small>
                  View User

                  <v-icon color="orange darken-4" right>
                    mdi-open-in-new
                  </v-icon>
                </v-btn>
              </v-list-item-action> -->
    <!-- </v-list-item>
          </template>
        </v-virtual-scroll>
      </v-list>
    </v-menu> -->

    <!-- <v-btn
      class="ml-2"
      min-width="0"
      text
      to="/pages/user"
    >
      <v-icon>mdi-account</v-icon>
    </v-btn> -->
    <!-- 
    <v-btn icon to="/app/settings/public">
      <v-icon>mdi-brightness-5</v-icon></v-btn
    > -->
    <languages />
    <download />
    <v-btn icon @click="setMode"> <v-icon>mdi-theme-light-dark</v-icon></v-btn>
    <v-btn icon to="/app/about"> <v-icon>mdi-information</v-icon></v-btn>
    <dataPrivacy />
  </v-app-bar>
</template>

<script>
// Components
import { VHover, VListItem } from "vuetify/lib";
import download from "./Download";
import dataPrivacy from "./dataPrivacy.vue";
import languages from "./languagesView.vue";
// Utilities
import { mapState, mapMutations } from "vuex";

export default {
  name: "appCoreAppBar",

  components: {
    AppBarItem: {
      render(h) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }) => {
              return h(
                VListItem,
                {
                  attrs: this.$attrs,
                  class: {
                    "black--text": !hover,
                    "white--text primary elevation-12": hover,
                  },
                  props: {
                    activeClass: "",
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                },
                this.$slots.default
              );
            },
          },
        });
      },
    },
  },
  components: { download, languages, dataPrivacy },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({}),
  computed: {
    ...mapState(["darkMode"]),
    ...mapState(["drawer"]),
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      },
    },

    userMe() {
      return this.$store.getters["users/userMe"];
    },
  },

  methods: {
    setMode() {
      this.$store.dispatch("changeDarkMode", !this.darkMode);
      this.$vuetify.theme.dark = this.darkMode;
    },
    ...mapMutations({
      setDrawer: "SET_DRAWER",
    }),
  },
};
</script>
